import { track } from '@vercel/analytics';

const GA_ID = 'G-68MV2GEXCG';

// Regista um clique ou ação importante (ex: 'clique_whatsapp') para saber o que traz contactos.
// - Google Analytics: só se o visitante aceitou cookies (o gtag só existe depois disso).
// - Vercel Analytics: sem cookies, por isso pode registar sempre (só guarda o nome e as
//   propriedades, nunca dados pessoais).
// Nunca passar nomes, telefones, emails ou textos escritos pelo visitante.
export function registarEvento(nome, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') window.gtag('event', nome, params);
  } catch (err) {
    // medir nunca pode estragar o site
  }
  try {
    track(nome, params);
  } catch (err) {
    // idem
  }
}

// Só injeta o Google Analytics depois de o utilizador aceitar cookies não
// essenciais (ver CookieBanner). Nunca carregar sem consentimento.
export function carregarGoogleAnalytics() {
  if (window.__gaCarregado) return;
  window.__gaCarregado = true;

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}
